import { AxiosResponse } from "axios";
import { AliasViewModel } from "../aliases/AliasStore";
import { MatchParticipantViewModel } from "../matches/MatchesStore";
import axios, { APIWrapperResponse, DefaultResponse, TypedResponse } from "../general/HttpClient";
import { AgentConfig, LEDBarConfig } from "../agents/AgentsStore";

export function getEvents(organizationID) {
    return axios.get("/api/Events/getEvents", { params: { organizationID } }).then((response: AxiosResponse<APIWrapperResponse<Array<EventViewModel>>>) => {
        return response.data.result;
    });
}

export function getEvent(id) {
    return axios.get(`/api/Events/getEvent/${id}`).then((response: AxiosResponse<APIWrapperResponse<EventViewModel>>) => {
        return response;
    });
}

export function createEvent(request: CreateEventRequest) {
    return axios.post(`/api/Events/createEvent`, request).then((response: AxiosResponse<APIWrapperResponse<TypedResponse<EventViewModel>>>) => {
        return response.data.result;
    });
}

export function updateEvent(request: UpdateEventRequest | EventViewModel) {
    return axios.put(`/api/Events/updateEvent`, request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export interface EventViewModel {
    id: string;
    organizationID: string;
    name: string;
    config: EventConfig;
}

export interface EventConfig {
    staticUrls: StaticUrl[];
    agents: { [key: string]: AgentConfig };
    ledBarActions: { [key: string]: LEDBarConfig };
}

export interface StaticUrl {
    name: string;
    url: string;
}

export interface CreateEventRequest {
    organizationID: string;
    name: string;
}

export interface UpdateEventRequest {
    organizationID: string;
    id: string;
    name: string;
    config: EventConfig;
}
